import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import React, {  useEffect, useState } from 'react';
import { EDGE } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import {
  Row,
  Col,
  Form,
  Slider,
  TimePicker,
  Button,
  InputNumber,    
  message,
  Select,
  Modal,
} from 'antd';

const { Option } = Select;
const columns = [
  {
    title: 'S.No',
    dataIndex: 'sno',
    key: 'sno'
  },
  {
    title: 'Parameter Name',
    dataIndex: 'ParameterName',
    key: 'ParameterName'
  },

  {
    title: 'Value',
    dataIndex: 'Value',
    key: 'Value'
  },
  {
    title: 'Submitted TimeStamp',
    dataIndex: 'SubmittedTime',
    key: 'SubmittedTime'
  },
  {
    title: 'Updated TimeStamp',
    dataIndex: 'UpdatedTime',
    key: 'UpdatedTime'
  },
  {
    title: 'Created By',
    dataIndex: 'CreatedBy',
    key: 'CreatedBy'
  }
];

const SmartControlTags = (props) => {
  
  const [visible,setVisible] = useState(false);
  const [parameterList,setParameterList] = useState([]);
  const [minValue,setMinValue] = useState(0);
  const [maxValue,setMaxValue] = useState(10);
  const [parameterValue,setParameterValue] = useState(0);
  const [selectedParameter,setSelectedParameter] = useState('');
  const [dataSource,setDataSource] = useState([]);
  const [userProfile,setUserProfile] = useState(props.userProfile);
  const [time,setTime] = useState(moment().format('HH:mm'));


  // eslint-disable-next-line react/no-deprecated
  // componentWillMount = () => {
  //   this.historyLog();
  // };

  useEffect(() => {
    getFormData();
    historyLog(); 
  }, []);
  

  useEffect(() => {
     setUserProfile(props.userProfile);
  },[props.userProfile]);
  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    //clearInterval(timeTicker)
    setVisible(false);
  };

  const getFormData = () => {
    // const siteId = localStorage.get("currentSite");
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const parameterGroup = {
      method: 'GET',
      url: `${EDGE.List} `,
      headers: {
        Authorization: Authorization
      }
    };
    axios(parameterGroup)
      .then((res) => {
        setParameterList(res.data);
      })
      .catch(() => { });
  };
  const handleSubmit = () => {
   
    let siteId = localStorage.get('currentSite');

    let payload = {};

    if (selectedParameter === '' || parameterValue === '' || time === '') {
      message.error('Please Provide SetPoints');
    } else if ((selectedParameter !== '' && parameterValue !== '') || time === '') {
      payload = {
        siteId: siteId,
        CreatedBy: userProfile && userProfile.user ? userProfile.user.Id : '',
        ParameterName: selectedParameter,
        Value: parameterValue,
        //  UpdatedTime:Time,
        SubmittedTime: time
      };

      formSubmittion(payload);
    }
  };
  const formSubmittion = (payload) => {
    // let siteId = localStorage.get("currentSite");
    const accessToken = localStorage.get('accessToken');
    const formSubmittionObject = {
      method: 'POST',
      url: `${EDGE.CREATE}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(formSubmittionObject)
      .then((response) => {
        message.success('Submitted Successfully');
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const historyLog = () => {
    const accessToken = localStorage.get('accessToken');
    const historyLogData = {
      method: 'POST',
      url: `${EDGE.Get}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
      //data: payload,
    };
    axios(historyLogData)
      .then((response) => {
        setDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const parameterChange = (value) => {

    let filterdArray = parameterList.filter((item) => item.ParameterName === value);
    setMinValue(filterdArray[0].minValue);
    setMaxValue(filterdArray[0].maxValue);
    setSelectedParameter(filterdArray[0].ParameterName);
  };
  const onTimePickerChnage = (value) => {
    setTime(moment(value).format('HH:mm'));
  };

return (
      <div className="mode1" style={{ padding: '50px' }}>
        <Button
          style={{ float: 'right', marginTop: '12px' }}
          type="primary"
          shape="round"
          
          onClick={() => {
            setVisible(true);
          }}
        >
          Test
        </Button>

        <Form>
          <div className="mode3">
            <Row>
              <Col span={5}>
                <Form.Item style={{ width: '200px' }} label="Select Parametr :">
                  <Select
                    onChange={(value) => parameterChange(value)}
                    placeholder="Please Select Parameter"
                  >
                    {parameterList.map((item, i) => {
                      return (
                        <Option value={item.ParameterName} key={i}>
                          {item.ParameterName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <h4 style={{  fontWeight: 'bold', color: '#000' }}>
                  Select Range
                </h4>
                <div className="sliderBackground">
                  <Slider
                    //marks={marks}
                    min={minValue}
                    max={maxValue}
                    value={parameterValue}
                    onChange={(value) => setParameterValue(value)}
                    tooltip={(value) => {
                      return `${value}`;
                    }}
                  />
                </div>
              </Col>
              <Col span={2}>
                <InputNumber
                  min={minValue}
                  max={maxValue}
                  style={{
                    width: '60px',
                    height: '50px',
                    marginTop: '35px',
                    marginLeft: '5px'
                  }}
                  value={parameterValue}
                  onChange={(value) => setParameterValue(value)}
                // step={0.01}
                />
              </Col>
              <Col span={5}>
                <Form.Item  label="Select Time :">
                  <TimePicker
                    style={{ width: '80%' }}
                    onChange={(e) => onTimePickerChnage(e)}
                    //disabledMinutes={(e)=>this.getDisabledMinutes("activate")}
                    format={'HH:mm'}
                    // defaultValue={moment('12:08', format)} format={format}
                    placeholder={'HH:mm'}

                  // format={format}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Button
            style={{ marginLeft: '45%', marginTop: '60px' }}
            type="primary"
            shape="round"
            
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>

          <br />
        </Form>

        <Modal
          open={visible}
          title="test"
          width={750}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Close
            </Button>
          ]}
        >
          <StyledTable size="small"
            columns={columns}
            dataSource={dataSource}
          />
        </Modal>
      </div>
    );
  
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(SmartControlTags);
